import styles from './ArticleLayout.module.scss';

interface ComponentProps {
  children: React.ReactNode;
}

export const ArticleLayout = ({ children }: ComponentProps) => {
  return <main className={styles.mainmiddle}>{children}</main>;
};
